<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template>

        <t-input v-model="form.typeBuildingMaterialId" hidden/>

        <b-row>

          <t-input v-model="form.name" cols="9" :add-error="error.name" label="Tipo de Material" required/>

          <t-input v-model="form.typeBuildingMaterialCodeLabel"
                   v-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_MANUAL"
                   :add-error="error.typeBuildingMaterialCodeLabel" upper cols="3"
                   label="Cód. Material"
                   help="Código inserido manualmente conforme configurado em Produtos > Configurações > Parâmetros"
                   required/>

          <t-input v-model="form.typeBuildingMaterialCodeLabel"
                   v-else-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_AUTOMATIC_DEFAULT"
                   :add-error="error.typeBuildingMaterialCodeLabel" upper cols="3"
                   fixed
                   label="Cód. Material"
                   help="Código inserido automaticamente conforme configurado em Produtos > Configurações > Parâmetros"
          />

        </b-row>

        <t-input v-model="form.unit" radio :options="UnitType.list" label="Un. Medida" required/>

        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

        <t-input-status v-model="form.status"/>

      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import SectorService from "@/services/modules/agent/Sector.service";
import SettingType from "@/model/types/resource/SettingType";
import UnitType from "@/model/types/modules/general/UnitType";
export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'TypeBuildingMaterialForm',
  data() {
    return {
      UnitType,
      SettingType,
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: false,
      fieldKey: "typeBuildingMaterialId",
      form: {
        typeBuildingMaterialId: 0,
        typeBuildingMaterialNumber: 0,
        typeBuildingMaterialCodeLabel: "",
        name: "",
        note: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        typeBuildingMaterialCodeLabel: "",
        name: "",
        sectorId: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      modeCodeLabel: "",
      sectorOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      this.modeCodeLabel = this.getRenderRule(SettingType.render.RENDER_TAG_COD_LABEL)

      await SectorService.selectList().then((list) => {
        this.sectorOptions = list
      }).catch(error => this.responseError(error))

      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  }

}
</script>

